<template>
  <div>
    <md-table class="bottom" v-model="tableData" :table-header-color="tableHeaderColor">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="序号">{{ item.level }}</md-table-cell>
        <md-table-cell md-label="数据名称">{{ item.name }}</md-table-cell>
        <md-table-cell md-label="数据描述">{{ item.description }}</md-table-cell>
        <md-table-cell md-label="数据类型">{{ getTypeString(item.type) }}</md-table-cell>
        <!--<md-table-cell md-label="存储类型">{{ item.ds_type_class }}</md-table-cell>-->

        <md-table-cell md-label="操作">
          <!--<base-button-->
          <!--outline=""-->
          <!--icon="ni ni-cloud-download-95"-->
          <!--type="warning"-->
          <!--@click.native="handleDownload(item)">-->
          <!--</base-button>-->

          <!--<base-button-->
          <!--outline=""-->
          <!--icon="ni ni-app"-->
          <!--type="warning"-->
          <!--@click.native="handlePreview(item)">-->
          <!--</base-button>-->
          <base-button
            outline
            type="warning"
            @click="preview(item)"
            role="button"
            icon="ni ni-atom"
          >预览</base-button>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth.js";
export default {
  name: "simple-table",
  props: {
    tableHeaderColor: {
      type: String,
      default: ""
    },
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  mounted() {},
  data() {
    return {
      previewString:
        "http://piecloud.piesat.cn/dataservices/pie-map-manager/static/pie-map/map.html?map=GFImage",
      users: [
        {
          name: "Dakota Rice",
          salary: "$36,738",
          country: "Niger",
          city: "Oud-Turnhout"
        },
        {
          name: "Minerva Hooper",
          salary: "$23,738",
          country: "Curaçao",
          city: "Sinaai-Waas"
        },
        {
          name: "Sage Rodriguez",
          salary: "$56,142",
          country: "Netherlands",
          city: "Overland Park"
        },
        {
          name: "Philip Chaney",
          salary: "$38,735",
          country: "Korea, South",
          city: "Gloucester"
        },
        {
          name: "Doris Greene",
          salary: "$63,542",
          country: "Malawi",
          city: "Feldkirchen in Kārnten"
        },
        {
          name: "Mason Porter",
          salary: "$78,615",
          country: "Chile",
          city: "Gloucester"
        }
      ],
      token: ""
    };
  },
  methods: {
    getTypeString(type) {
      switch (type) {
        case 0:
          return "栅格";
        case 1:
          return "矢量";
        case 2:
          return "地形";
        case 3:
          return "地图风格";
        default:
          return "全部";
      }
    },
    handleDownload(item) {},
    handleLink(item) {},
    handlePreview(item) {
      console.log(item);
      window.history.href =
        "http://piecloud.piesat.cn/dataservices/pie-map-manager/static/pie-map/map.html?map=GFImage" +
        "&zoom=" +
        item.default_layer;
      "&mapcenterX=" + item.center_point_x;
      "&mapcenterY=" + item.center_point_y;
    },
    tokenValue() {
      this.token = getToken();
    },
    preview(item) {
      let url =
        item.mapUrl +
        "&zoom=" +
        (item.defaultLayer == null ? "" : item.defaultLayer);
      if (item.projection == "Web_Mercator") {
        let center = this.lnglatToMercator(
          item.centerPointX,
          item.centerPointY
        );
        url +=
          "&mapcenterX=" +
          center[0] +
          "&mapcenterY=" +
          center[1] +
          "&epsg=" +
          3857;
      } else if (item.projection == "WGS_84") {
        let center = [];
        if (item.centerPointX == null || item.centerPointY == null) {
          center = [116.39, 39.92];
        } else {
          center = [item.centerPointX, item.centerPointY];
        }
        url +=
          "&mapcenterX=" +
          center[0] +
          "&mapcenterY=" +
          center[1] +
          "&epsg=" +
          4326;
      }
      if (item.mapUrl.indexOf("url")==-1) {
        url += "&access_token=" + this.token;
      }
    //   url = url.replace("http://piecloud.piesat.cn/dataservices/pie-map-manager","http://localhost:8989")
      window.open(url);
    },

    lnglatToMercator(x, y) {
      if (x == null || y == null) {
        return [12956543.63791542, 4852847.862769264];
      }
      let lnglat = [];
      var earthRad = 6378137.0;
      lnglat[0] = ((x * Math.PI) / 180) * earthRad;
      var a = (y * Math.PI) / 180;
      lnglat[1] =
        (earthRad / 2) * Math.log((1.0 + Math.sin(a)) / (1.0 - Math.sin(a)));
      return lnglat;
    }
  },
  mounted() {
    this.tokenValue();
  }
};
</script>
<style>
.md-table-fixed-header-active {
  border-bottom: none !important;
}
</style>
